export const state = {
  searching: false,
  showCartDetails: false,
  showTerms: false,
  showPrivacy: false,
  alert: {
    message: '',
    type: 'success',
  },
  property: null,
}

export const getters = {}

export const mutations = {
  BEGIN_SEARCHING(state) {
    state.searching = true
  },
  END_SEARCHING(state) {
    state.searching = false
  },
  SHOW_CART(state) {
    state.showCartDetails = true
  },
  HIDE_CART(state) {
    state.showCartDetails = false
  },
  TOGGLE_TERMS(state, val = false) {
    state.showTerms = val
  },
  TOGGLE_PRIVACY(state, val = false) {
    state.showPrivacy = val
  },
  SET_ALERT(state, { message = '', type = 'success' }) {
    state.alert = Object.assign({}, { message, type })
  },
}

export const actions = {}
